import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './auth.json';

const checkPageAuthorization = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['authorizationController/checkPageAuthorization'].success.default)));
};

const fakeLoginValidate = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['authorizationController/fakeLoginValidate'].success.default)));
};

const getLoginStatus = (req, res, ctx) => {
  // const mockType = req.headers.get('x-mock-response');
  // if (mockType === "error") return serverErrorResponse();

  return res(ctx.json(mockResponse(apiResponses['authorizationController/getLoginStatus'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('authorizationController/checkPageAuthorization'), withScenario(checkPageAuthorization)),
  rest.post(getApiEndpoint('authorizationController/getLoginStatus'), withScenario(getLoginStatus)),
  rest.post(
    getApiEndpoint('authorizationController/fakeLoginValidate'),
    withScenario(withAuthCheck(fakeLoginValidate))
  ),
];
